<div class="ra-page">

  <!-- Title + CTA -->
  <div class="ra-page__header">
    <h1 class="ra-page__title">Report Automation</h1>
    <button type="button" class="ra-page__new-btn" (click)="openNewReport()">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
        <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
      </svg>
      New Report
    </button>
  </div>

  <!-- Table card -->
  <div class="ra-table-card">

    <!-- Card header: label + search -->
    <div class="ra-table-card__head">
      <p class="ra-table-card__list-label">List of reports</p>
      <div class="ra-table-card__search">
        <svg width="19" height="19" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/>
          <path d="m20 20-3-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <input
          [value]="search"
          (input)="onSearch($event.target.value)"
          placeholder="Search"
          class="ra-table-card__search-input"
        />
      </div>
    </div>

    <!-- Filter bar -->
    <div class="ra-table-card__filters">

      <div class="ra-table-card__filter-group">
        <span class="ra-table-card__filter-label">Type</span>
        <one-select
          label="All types"
          size="small"
          [dataSource]="typeSelectOptions"
          [config]="simpleSelectConfig"
          [value]="selectedTypeOption"
          (selectionChanged)="onFilterType($event.name)"
        ></one-select>
      </div>

      <div class="ra-table-card__filter-group">
        <span class="ra-table-card__filter-label">Date range</span>
        <one-range-datepicker
          [start]="filterFromControl"
          [end]="filterToControl"
        ></one-range-datepicker>
      </div>

      <button
        *ngIf="hasActiveFilters"
        type="button"
        class="ra-table-card__filter-reset"
        (click)="resetFilters()"
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
        </svg>
        Reset filters
      </button>

    </div>

    <!-- Column headers -->
    <div class="ra-table-card__col-headers">
      <span>REPORT TYPE</span>
      <span>MAKER</span>
      <span>COUNTRY</span>
      <span>REQUESTED AT</span>
      <span>STATUS</span>
      <span *ngIf="false">DOWNLOAD</span>
      <span *ngIf="false"></span>
    </div>

    <!-- Rows -->
    <div
      *ngFor="let r of pageItems; trackBy: trackById"
      class="ra-table-card__row"
    >
      <span class="ra-table-card__cell ra-table-card__cell--type">{{ r.type }}</span>
      <span class="ra-table-card__cell ra-table-card__cell--muted">{{ r.maker }}</span>
      <span class="ra-table-card__cell ra-table-card__cell--muted">{{ r.country }}</span>
      <span class="ra-table-card__cell ra-table-card__cell--muted">{{ r.requestedAt }}</span>
      <div class="ra-table-card__cell">
        <span
          class="ra-table-card__status-pill"
          [ngStyle]="{ background: r.statusBg, color: r.statusFg }"
        >{{ r.status }}</span>
      </div>
      <div *ngIf="false" class="ra-table-card__cell">
        <a *ngIf="r.status === 'Ready' && r.url" [href]="r.url" target="_blank" rel="noopener noreferrer" class="ra-table-card__action ra-table-card__action--download">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
            <path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 19h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
          PPTX
        </a>
        <span *ngIf="r.status === 'In progress'" class="ra-table-card__action ra-table-card__action--generating">
          <span class="ra-table-card__spinner"></span>
          Generating…
        </span>
      </div>
      <div *ngIf="false" class="ra-table-card__cell ra-table-card__cell--kebab">
        <button type="button" class="ra-table-card__kebab-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="5" r="1.7"/><circle cx="12" cy="12" r="1.7"/><circle cx="12" cy="19" r="1.7"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="loading" class="ra-table-card__empty">
      <span class="ra-table-card__spinner"></span>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && noResults" class="ra-table-card__empty">
      <p class="ra-table-card__empty-title">No reports found</p>
      <p class="ra-table-card__empty-hint">Try adjusting your search or filters.</p>
    </div>

    <!-- Pagination footer -->
    <div class="ra-table-card__pagination">
      <div class="ra-table-card__page-size">
        <span>Show</span>
        <select [value]="pageSize" (change)="onPageSize(+$event.target.value)" class="ra-table-card__page-size-select">
          <option [value]="5">5</option>
          <option [value]="10">10</option>
          <option [value]="20">20</option>
        </select>
      </div>
      <div class="ra-table-card__page-nav">
        <button
          type="button"
          class="ra-table-card__page-btn"
          [disabled]="!canPrev"
          (click)="prevPage()"
        >
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="ra-table-card__range-label">{{ rangeLabel }}</span>
        <button
          type="button"
          class="ra-table-card__page-btn"
          [disabled]="!canNext"
          (click)="nextPage()"
        >
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

  </div>

</div>

